import "$styles/index.scss"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import * as Popper from "@popperjs/core"
import Dropdown from "bootstrap/js/dist/dropdown"
import Collapse from "bootstrap/js/dist/collapse"

